module.exports = __webpack_public_path__ + "static/media/dec.2fc9c74b.png";